module.exports = __webpack_public_path__ + "static/media/R-280HD.b0af1e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/R-280HD.png
// module id = 2102
// module chunks = 0